module.exports = __webpack_public_path__ + "img/ion_checkmark_ionicons.d7fe511e.svg";